export type Track = {
  id: string;
  imageIdOverride?: string;
  link: string | undefined;
  mapperName: string | undefined;
  name: string;
};

export const getTrackImageId = (track: Track) => {
  return track.imageIdOverride ?? track.id;
};

export const getTrackThumbnailPath = (track: Track | string) => {
  if (typeof track === "string") {
    return `/images/tracks/${track}/thumbnail.jpg`;
  }
  return `/images/tracks/${getTrackImageId(track)}/thumbnail.jpg`;
};
